// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__pGMkO","list":"PatternAutocomplete_list__kyvRq"};